// extracted by mini-css-extract-plugin
export default {"container":"UniversityExplorationSubmission_container__oaq1l"};